module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "id": "merchandises"
    }
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2rem",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "page-detail"
  }, [_c('div', {
    staticClass: "content-block"
  }, [_vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "0rem"
    },
    attrs: {
      "id": "tab-detail"
    }
  }, _vm._l((_vm.priceDetail), function(data) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "0.3rem",
        "margin-top": "1.2rem",
        "margin-left": "0.2rem",
        "margin-right": "0.2rem"
      }
    }, [_c('div', [_c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(data.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(data.price))]), _vm._v(" "), _vm._m(1, true)])])])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "2rem",
      "margin-top": "0.6rem"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "color": "#00469A",
      "font-size": "1.2rem"
    }
  }, [_vm._v("价格明细")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06fcc2de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Cust/Detail/CustPriceDetail.vue
// module id = 1526
// module chunks = 8